import { Link } from 'react-router-dom';
import { Heart, Phone, Mail, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="footer-elegant">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Social Media Section */}
        <div className="flex justify-center gap-6 mb-8 pb-8 border-b border-gold/30">
          <a 
            href="https://www.google.com/search?q=officine+delcuore+napoli&oq=officine+delcuore+napoli&gs_lcrp=EgZjaHJvbWUyBggAEEUYOdIBCDU3MjdqMGo3qAIAsAIB&sourceid=chrome&ie=UTF-8"
            target="_blank"
            rel="noopener noreferrer"
            className="social-logo-link"
          >
            <img 
              src="https://customer-assets.emergentagent.com/job_officine-cuore/artifacts/la6njfdu_google-reviews-logo.webp"
              alt="Google Reviews"
              className="h-16 w-auto hover:scale-110 transition-transform duration-300"
            />
          </a>
          <a 
            href="https://www.facebook.com/OfficineDelCuoreAgenziaPerSingle"
            target="_blank"
            rel="noopener noreferrer"
            className="social-logo-link"
          >
            <img 
              src="https://customer-assets.emergentagent.com/job_officine-cuore/artifacts/7335olo0_logo%20faceb.webp"
              alt="Facebook"
              className="h-16 w-auto hover:scale-110 transition-transform duration-300"
            />
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1">
            <Link to="/" className="flex items-center space-x-2 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_officine-cuore/artifacts/upmb4kcx_NUOVO%20LOGO%20OFFICINE2.webp" 
                alt="Officine del Cuore Logo" 
                className="h-12 w-auto"
              />
              <div className="flex flex-col">
                <span className="brand-name text-lg">Officine del Cuore</span>
                <span className="brand-tagline text-xs">Dal 2006</span>
              </div>
            </Link>
            <p className="footer-text">
              L'agenzia matrimoniale che da 19 anni crea incontri autentici e relazioni durature.
            </p>
          </div>

          {/* Links */}
          <div className="col-span-1">
            <h3 className="footer-heading">Navigazione</h3>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/chi-siamo">La Nostra Storia</Link></li>
              <li><Link to="/come-funziona">Il Nostro Metodo</Link></li>
              <li><Link to="/agenzia-matrimoniale-napoli">Napoli</Link></li>
              <li><Link to="/agenzia-matrimoniale-caserta">Caserta</Link></li>
              <li><Link to="/agenzia-matrimoniale-roma">Roma</Link></li>
              <li><Link to="/contatti">Scrivici</Link></li>
            </ul>
          </div>

          {/* Sedi */}
          <div className="col-span-1">
            <h3 className="footer-heading">Le Nostre Sedi</h3>
            <div className="space-y-4">
              {/* Napoli */}
              <div>
                <div className="flex items-start space-x-2 footer-text">
                  <MapPin size={18} className="text-gold mt-1 flex-shrink-0" />
                  <div>
                    <p className="font-medium text-burgundy">Napoli</p>
                    <p className="text-sm">Via G. Testa, 16</p>
                  </div>
                </div>
              </div>
              {/* Caserta */}
              <div>
                <div className="flex items-start space-x-2 footer-text">
                  <MapPin size={18} className="text-gold mt-1 flex-shrink-0" />
                  <div>
                    <p className="font-medium text-burgundy">Caserta</p>
                    <p className="text-sm">Viale Vincenzo Cappiello, 8</p>
                  </div>
                </div>
              </div>
              {/* Roma */}
              <div>
                <div className="flex items-start space-x-2 footer-text">
                  <MapPin size={18} className="text-gold mt-1 flex-shrink-0" />
                  <div>
                    <p className="font-medium text-burgundy">Roma</p>
                    <p className="text-sm">Via Mattia Battistini, 466a</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Contatti */}
          <div className="col-span-1">
            <h3 className="footer-heading">Contatti</h3>
            <div className="space-y-4">
              {/* Napoli */}
              <div>
                <p className="text-xs font-medium text-burgundy mb-2">Napoli</p>
                <ul className="space-y-2">
                  <li>
                    <a href="tel:+393292626152" className="flex items-center space-x-2 footer-text hover:text-gold transition-colors text-sm">
                      <Phone size={16} />
                      <span>+39 3292626152</span>
                    </a>
                  </li>
                  <li>
                    <a href="mailto:info@officinedelcuore.it" className="flex items-center space-x-2 footer-text hover:text-gold transition-colors text-sm">
                      <Mail size={16} />
                      <span>info@officinedelcuore.it</span>
                    </a>
                  </li>
                </ul>
              </div>
              {/* Caserta */}
              <div>
                <p className="text-xs font-medium text-burgundy mb-2">Caserta</p>
                <ul className="space-y-2">
                  <li>
                    <a href="tel:+393520567001" className="flex items-center space-x-2 footer-text hover:text-gold transition-colors text-sm">
                      <Phone size={16} />
                      <span>+39 3520567001</span>
                    </a>
                  </li>
                  <li>
                    <a href="mailto:info@officinedelcuore.it" className="flex items-center space-x-2 footer-text hover:text-gold transition-colors text-sm">
                      <Mail size={16} />
                      <span>info@officinedelcuore.it</span>
                    </a>
                  </li>
                </ul>
              </div>
              {/* Roma */}
              <div>
                <p className="text-xs font-medium text-burgundy mb-2">Roma</p>
                <ul className="space-y-2">
                  <li>
                    <a href="tel:+393455006556" className="flex items-center space-x-2 footer-text hover:text-gold transition-colors text-sm">
                      <Phone size={16} />
                      <span>+39 3455006556</span>
                    </a>
                  </li>
                  <li>
                    <a href="mailto:info@officinedelcuore.it" className="flex items-center space-x-2 footer-text hover:text-gold transition-colors text-sm">
                      <Mail size={16} />
                      <span>info@officinedelcuore.it</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-burgundy/20 mt-8 pt-8 text-center">
          <p className="footer-text text-sm">
            © {new Date().getFullYear()} Officine del Cuore. Tutti i diritti riservati. | <Link to="/termini-servizio" className="hover:text-gold transition-colors">Termini del Servizio</Link> | <Link to="/privacy-policy" className="hover:text-gold transition-colors">Privacy Policy</Link>
          </p>
          <p className="footer-text text-xs mt-2 italic">
            Riservatezza assoluta garantita. I vostri dati sono al sicuro con noi.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
